export default {
    AueUrl: 'http://aue',        // 生产 http://aue   测试：http://jtv-ttsweb01-t:8008
    ApiPrefix: '',
    UserTokenKey: 'UserToken',
    RedirectUrlKey: 'RedirectUrl',
    CurrentOpenIDKey: 'CurrentOpenID',
    CurrentUserInfoKey: 'CurrentUserInfo',
    CurrentMenusKey: 'CurrentMenus',
    CurrentPermissionsKey: 'CurrentPermissions',
    CurrentConfigKey: 'CurrentConfig',
    CurrentTenantListKey:'CurrentTenantList',
    DefaultTenantKey:'DefaultTenant',
    MaxUploadFileSize: 100    // 文件上传大小，单位M
}

/*
http://cre.winourway.net/Account/Login
http://ican.ourway.net.cn/WSProcessAPI.asmx/WSProcessFunc
http://ican.api.com/WSProcessAPI.asmx/WSProcessFunc
*/